import type { RegisterTranslations } from "../interfaces/register";

export const registerTranslations: RegisterTranslations = {
  register_button: "Registrar-se",
  create_account_label_prefix: "Não tem uma conta?",
  create_account_label_button: "Cadastre-se",
  or_label: "Ou",
  input_name_label: "Nome",
  input_name_placeholder: "Digite seu nome",
  input_last_name_label: "Sobrenome",
  input_last_name_placeholder: "Digite seu sobrenome",
  terms_and_conditions_text: "Ao se registrar, você concorda com nossos termos e condições",

  page_title: "Crie sua conta",
  page_subtitle_persona: "Só precisamos dos seus dados pessoais para criar sua conta.",
  page_subtitle_empresa: "Registre seus dados pessoais e os da sua organização em uma única etapa.",

  account_type_label: "Como você quer se registrar?",
  account_type_persona_label: "Pessoa",
  account_type_persona_description: "Conta pessoal",
  account_type_empresa_label: "Empresa",
  account_type_empresa_description: "Registre sua organização",

  section_user: "Seus dados",
  section_user_heading: "Sobre você",
  section_user_description: "Informações que identificam sua conta pessoal.",
  section_organization: "Sua organização",
  section_organization_heading: "Espaço de trabalho",
  section_organization_description: "Informações que identificam sua organização.",

  terms_text_prefix: "Ao continuar você aceita os ",
  terms_link: "Termos",
  terms_text_middle: " e a ",
  privacy_link: "Política de privacidade",
  terms_text_suffix: ".",

  user_name_label: "Nome completo",
  user_name_placeholder: "Digite seu nome completo",
  user_email_label: "E-mail",
  user_email_placeholder: "voce@email.com",
  user_password_label: "Senha",
  user_password_placeholder: "Mínimo de 8 caracteres",
  user_country_label: "País",
  user_phone_label: "Telefone",
  user_phone_placeholder: "Número com prefixo internacional",

  org_name_label: "Nome da organização",
  org_name_placeholder: "Digite o nome da organização",
  org_email_label: "E-mail de contato",
  org_phone_label: "Telefone de contato",
  org_country_label: "País",

  hint_mirror_email: "Igual ao seu e-mail pessoal",
  hint_mirror_phone: "Igual ao seu telefone pessoal",
  hint_mirror_country: "Igual ao seu país pessoal",
  hint_mirror_org_name: "Sugerido a partir do seu nome",

  pwd_strength_empty: "Digite uma senha",
  pwd_strength_weak: "Fraca",
  pwd_strength_fair: "Aceitável",
  pwd_strength_good: "Boa",
  pwd_strength_strong: "Forte",
  pwd_strength_aria_label: "Indicador de força da senha",

  submit_button: "Criar conta",
  submit_loading: "Criando conta...",

  error_required: "Campo obrigatório",
  error_email: "E-mail inválido",
  error_name_length: "Deve ter entre 2 e 100 caracteres",
  error_org_name_length: "Deve ter entre 2 e 100 caracteres",
  error_password_min: "Mínimo de 8 caracteres",
  error_password_number: "Deve incluir pelo menos um número",
  error_password_symbol: "Deve incluir pelo menos um símbolo",
  error_phone_format: "Formato de telefone inválido (E.164)",
  error_country: "Selecione um país",
  error_email_conflict: "E-mail já cadastrado",
  error_generic: "Algo deu errado. Tente novamente.",

  verify_title: "Verifique seu e-mail",
  verify_subtitle: "Enviamos um código de 6 dígitos para confirmar sua conta.",
  verify_sent_to_label: "Enviamos o código para",
  verify_new_code_sent_to_label: "Enviamos um novo código para",
  verify_code_label: "Código de verificação",
  verify_submit_button: "Verificar e-mail",
  verify_submitting: "Verificando...",
  verify_resend_button: "Reenviar código",
  verify_resend_cooldown: "Reenviar código ({{seconds}}s)",
  verify_resend_sent: "Enviamos um novo código",
  verify_edit_email_link: "Alterar",
  verify_edit_email_aria: "Alterar o e-mail para o qual enviamos o código",
  verify_change_email_label: "E-mail correto",
  verify_change_email_hint: "Enviaremos um novo código para ele. Seus dados de cadastro continuam salvos.",
  verify_change_email_submit: "Enviar código",
  verify_change_email_submitting: "Enviando...",
  verify_change_email_cancel: "Cancelar",
  verify_change_email_success: "Pronto. Enviamos um novo código para {{email}}",
  verify_change_email_error_same: "É o mesmo e-mail para o qual já enviamos o código.",
  verify_change_email_error_in_use: "Já existe uma conta com este e-mail. Entre com ela ou use outro.",
  verify_change_email_error_org_in_use: "Já existe uma organização com este e-mail. Use outro.",
  verify_change_email_error_generic: "Não foi possível alterar o e-mail. Tente novamente.",
  verify_sign_out_prompt: "Quer entrar com outra conta?",
  verify_sign_out: "Sair",
  verify_success_toast: "E-mail verificado. Bem-vindo!",
  verify_error_invalid_code: "Código inválido. Verifique e tente novamente.",
  verify_error_invalid_code_format: "O código deve ter 6 dígitos",
  verify_error_expired: "O código expirou. Solicite um novo.",
  verify_error_already_verified: "Este e-mail já foi verificado.",
  verify_error_rate_limited: "Muitas tentativas. Aguarde alguns instantes e tente novamente.",
  verify_error_generic: "Não foi possível verificar o código. Tente novamente.",
};
